import styled from 'styled-components';
import { colors } from '../../utils/variables.styles';

const Info = styled.div`
  padding: 10px 24px;
  margin-top: 20px !important;
  background-color:${colors.mainLight};
`;

export {
  Info
};
